<div [ngClass]="'inline-flex items-center rounded-full pr-2 ' + classes">
  @if (icon) {
    <mat-icon
      [ngClass]="
        'ml-1 items-center justify-center text-sm ' +
        matIconTypeClass +
        ' ' +
        (iconClass || '')
      "
      style="display: inline-flex"
      >{{ icon }}</mat-icon
    >
  } @else if (dotClasses !== '') {
    <span [ngClass]="'m-2 h-2 w-2 rounded-full ' + dotClasses"></span>
  } @else {
    <span class="pl-2"></span>
  }
  <span class="text-xs">{{ text }}</span>
</div>
